/**
 * 登陆
 * Created at 2021-10-03 16:12
 * @author teapot
 */
import './index.css';
import { Button, Divider, Form, Image, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import home from '.././../components/navbar/image/home.png';
import search from '.././../components/navbar/image/search.png';
import logo from '.././../components/navbar/image/1111111.png';
import { useHistory } from 'react-router';
import http from '../../service/http';
import Api from '../../api';

const Login = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <div className='login'>
      <div className='login-top'>
        {/* <div className="home-item-placeholder" />

        <img
          src={home}
          alt={"首页"}
          onClick={() => {
            history.replace("/");
          }}
        />

        <Divider type="vertical" />

        <img
          alt={"搜索"}
          src={search}
          onClick={() => {
            history.replace("/search");
          }}
        /> */}

        <div className='home-item-placeholder' />
        <Image preview={false} src={logo} className='login-logo' onClick={() => { history.replace("/"); }} />
        <div className='home-item-placeholder login-menu'>
          {/* <img
            src={home}
            alt={'首页'}
            onClick={() => {
              history.replace('/');
            }}
          />

          <Divider type='vertical' />

          <img
            alt={'搜索'}
            src={search}
            onClick={() => {
              history.replace('/search');
            }}
          /> */}
        </div>
      </div>

      <Form
        name='basic'
        initialValues={{ remember: true }}
        onFinish={(value) => {
          http.post(Api.login, value).then((res) => {
            if (res && res.data && res.data.resp_code === 11000) {
              const token = res.data.access_token;
              localStorage.setItem('access_token', token);

              if (token) {
                history.replace('/');
              }
            }
          });
        }}
        // onFinishFailed={onFinishFailed}
        autoComplete='off'
        className='login-form'
      >
        <Form.Item
          name='account'
          rules={[{ required: true, message: t('login_null_user') }]}
        >
          <Input placeholder={t('login_null_user')} />
        </Form.Item>

        <Form.Item
          name='pwd'
          rules={[{ required: true, message: t('login_null_pwd') }]}
        >
          <Input.Password placeholder={t('login_null_pwd')} />
        </Form.Item>

        <Form.Item>
          <Button className='home-width' type='primary' htmlType='submit'>
            {t('login_submit')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
